import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import defaultEn from "../localization/resources/en/en.json";

export const initI18n = async (replaceTerms) => {
  const translations = {
    ...defaultEn,
    ...(replaceTerms || {}),
  };

  const resources = {
    en: {
      translations,
    },
  };

  await i18n
    .use(LanguageDetector)
    .init({
      debug: true,
      lng: "en",
      fallbackLng: "en",
      interpolation: {
        escapeValue: false,
      },
      pluralSeparator: '_',
      keySeparator: false,
      resources,
      ns: ["translations"],
      defaultNS: "translations",
    });
};

export default i18n;
